<template>
  <div class="industrial_parks">
    <page-box :title="title">
      <div class="content">
        <img src="@/assets/images/Situation/image33.png" alt="" class="pic" />
        <div class="sec_title">
          <div class="title_icon"></div>
          <div class="text_content">{{ form }}</div>
        </div>
      </div>
    </page-box>
  </div>
</template>

<script setup>
import PageBox from '@/components/pageBox/PageBox';
import { ref, reactive } from 'vue';
const props = defineProps({
  title: {
    type: String,
    required: true,
  },
});
const form = ref('区财政局局长莅临何氏蹦蹦鱼食品产业园指导工作');
</script>

<style lang="scss" scoped>
.industrial_parks {
  margin-bottom: 5px;
  .content {
    margin-left: 18px;
    width: 318px;
    .pic {
      width: 318px;
      height: 176.67px;
    }
    .sec_title {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 0px;
      .title_icon {
        margin-top: -15px;
        margin-left: -7px;
        width: 57px;
        height: 30px;
        background-size: 100% 100%;
        background-image: url(@/assets/images/Introduce/style.png);
        margin-right: 6px;
      }
    }

    .text_content {
      // padding: 0 12px;
      box-sizing: border-box;
      width: 100%;
      color: #fff;
      font-family: MiSans;
      font-size: 17px;
      font-style: normal;
      font-weight: 600;
      line-height: 24px; /* 150% */
      // letter-spacing: -0.237px;
    }
  }
}
</style>
